import { ReactNode } from 'react';
import { Hero } from './Hero';
import { Nav } from './Nav';

export function ScrollyArticle(props: {
    children: ReactNode;
    showHero?: boolean;
}) {
    return (
        <div>
            <Nav />
            {props.showHero && <Hero />}
            <div className="px-4 sm:px-12 w-full max-w-6xl mx-auto pt-12 pb-64 h-full">
                {props.children}
            </div>
        </div>
    );
}
